import { render, staticRenderFns } from "./Packaging.vue?vue&type=template&id=6ff4efe2&scoped=true"
import script from "./Packaging.vue?vue&type=script&lang=js"
export * from "./Packaging.vue?vue&type=script&lang=js"
import style0 from "./Packaging.vue?vue&type=style&index=0&id=6ff4efe2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ff4efe2",
  null
  
)

export default component.exports